// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3ZAON","inputWrap":"styles_inputWrap__2dzVT","input":"styles_input__26YFF"};